<template>
  <div class="main-container">
    <v-container class="pa-0" fluid>
      <div class="px-3 px-md-0 py-5">
        <h1 class="header">
          <div v-if="level === 1">
            {{ $t("explore.admission_system_undergraduate") }}
            <!-- {{ explore_year_text_1 }} -->
          </div>
          <div v-if="level === 2">
            {{ $t("explore.admission_system_master") }}
            <!-- {{ explore_year_text_2 }} -->
          </div>
          <div v-if="level === 3">
            {{ $t("explore.admission_system_phd") }}
            <!-- {{ explore_year_text_3 }} -->
          </div>
        </h1>
        <h4 class="sub-header">
          {{ $t("app_bar.university_name") }}
        </h4>
      </div>
      <LauncherTabs :page="String(level)" />
      <ExploreDisplay
        :level="1"
        v-show="level === 1"
        :update_year_text="update_year_text"
      />
      <ExploreDisplay
        :level="2"
        v-show="level === 2"
        :update_year_text="update_year_text"
      />
      <ExploreDisplay
        :level="3"
        v-show="level === 3"
        :update_year_text="update_year_text"
      />
    </v-container>
  </div>
</template>

<script>
import LauncherTabs from "@/components/explore_page/LauncherTabs";
import ExploreDisplay from "@/components/explore_page/ExploreDisplay";

export default {
  name: "Explore",
  components: {
    LauncherTabs,
    ExploreDisplay,
  },
  props: {
    level: Number,
  },
  data: () => ({
    explore_year_text_1: "",
    explore_year_text_2: "",
    explore_year_text_3: "",
  }),
  methods: {
    update_year_text(level, text) {
      this["explore_year_text_" + level] = text;
    },
  },
  created() {
    const redirect = localStorage.getItem('applicant_info_general');
    if (redirect === 'true') {
      localStorage.removeItem('applicant_info_general'); 
      setTimeout(() => {
        this.$router.push({ name: 'applicant_info_general' }); 
      }, 1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header {
  font-size: 2em !important;
  color: rgb(255, 255, 255);
  text-shadow: 1px 1px 1px #000000cc;
}

.sub-header {
  color: #ff3c00;
  background-color: rgba(255, 255, 255, 0.5);
  // padding: 0px 10px 0px 10px;
  width: auto;
}
</style>
